import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {animate, AnimationEvent, style, transition, trigger} from '@angular/animations';
import {MegaMenuItem} from 'primeng/api';
import {AppComponent} from './app.component';
import {Subscription} from "rxjs";
import {OAuthService} from "angular-oauth2-oidc";
import {UiSettingUserDto} from "../../../../features/core/ui/model/dto/entity/ui-setting-user.dto";
import {
    UiUserThemeConfigurations
} from "../../../../features/core/ui/component/protected-components/ui-setting-user/data/ui-user-theme-configurations";
import {AppMainComponent} from "./app.main.component";
import {TopbarService} from "../../../../features/core/shared/service/topbar/topbar.service";
import {MvsObjectNavigationService} from "../../../../features/core/shared/navigation/mvs-object-navigation.service";
import {UmUserService} from "../../../../features/feature-core/um/service/api/um-user.service";
import {MvsCoreService} from "../../../../features/core/shared/service/mvs-core.service";
import {UiSettingUserService} from "../../../../features/core/ui/service/api/ui-setting-user.service";
import {TenantService} from "../../../../features/auth/tenant/tenant.service";
import {IndicatorButton} from "../../../../features/core/shared/service/indicator-button";
import {MvsObjectNavigationEntry} from "../../../../features/core/shared/navigation/mvs-object-navigation-entry";
import {UserProfileHelper} from "../../../../features/core/shared/form/helper/user-profile-helper";
import {FilterCriteria} from "../../../../features/core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../features/core/shared/dto/object/request/object-request-list";
import {
    UiThemeInterface
} from "../../../../features/core/ui/component/protected-components/ui-setting-user/data/ui-theme-interface";
import {ObjectIdentifier} from "../../../../features/core/shared/basic/object-identifier";
import {
    MvsObjectNavigationActionEnum
} from "../../../../features/core/shared/navigation/mvs-object-navigation-action-enum";
import {Router} from "@angular/router";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scaleY(0.8)' }),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: '*' })),
            ]),
            transition(':leave', [
                animate('.1s linear', style({ opacity: 0 }))
            ])
        ])
    ],
    styles: ['.topbar {\n' +
            '  display: flex;\n' +
            '  align-items: center;\n' +
            '  padding: 5px;\n' +
            // '  background-color: #f1f1f1;\n' +
            '}\n' +
            '\n' +
            '.overlay-item {\n' +
            '  cursor: pointer;\n' +
            '  padding: 5px;\n' +
            // '  margin: 0 5px;\n' +
            '}\n' +
            '\n' +
            '.overlay-item.active {\n' +
            '  font-weight: bold;\n' +
            '  color: #007bff;\n' +
            '}'],
    standalone: false
})
export class AppTopBarComponent implements OnInit, OnDestroy, AfterViewInit {

    tenantLogo?: string = undefined;
    tenantName?: string = undefined;
    profilePicture: string;
    uiUserSettings: UiSettingUserDto;
    userSettings: UiUserThemeConfigurations;
    busy: boolean = false;
    topbarBackground: string | null = null; // TM-1000001963: precomputed [style.background] to avoid NG0100

    constructor(
        public appMain: AppMainComponent,
        public app: AppComponent,
        protected topbarService: TopbarService,
        protected navigationService: MvsObjectNavigationService,
        protected userService: UmUserService,
        protected coreService: MvsCoreService,
        protected uiSettingUserService: UiSettingUserService,
        protected router: Router,
        protected oAuthService: OAuthService,
        private tenantService: TenantService,
        private cdr: ChangeDetectorRef) { // TM-1000001963
    }

    activeItem: number;
    buttons: IndicatorButton[] = [];
    indicatorSubscription: Subscription;
    currentOverlay: MvsObjectNavigationEntry[] = [];
    displayStack: MvsObjectNavigationEntry[] = [];
    objectLabel: string;
    activeOverlay: MvsObjectNavigationEntry;
    activeOverlayIndex: number;
    profileSubscription: Subscription;

    model: MegaMenuItem[] = [
        {
            label: 'Quick Access',
            items: [
                [
                    {
                        label: 'END USER APP',
                        items: [
                            { label: 'Konfiguration', icon: 'pi pi-fw pi-id-card', routerLink: ['/eu/euAppConfig'] },
                        ]
                    },
                    {
                        label: 'IMPORTER',
                        items: [
                            { label: 'Dashboard', icon: 'pi pi-fw pi-file', routerLink: ['/im/dashboard'] },
                            { label: 'Importieren', icon: 'pi pi-fw pi-file-import', routerLink: ['/im/dataImport'] },
                        ]
                    }
                ],
            ]
        },
        {
            label: 'Entity Browser',
            routerLink: ['/cc/entities']
        },
    ];

    @ViewChild('searchInput') searchInputViewChild: ElementRef;

    ngOnInit() {

        // TM-1000001963: tenantInfo can be null on first load (auth/tenant state not yet
        // populated). Guard the access so ngOnInit never crashes; once the tenant arrives
        // it is picked up via getTenantInfo()'s lazy localStorage refresh on later calls.
        const tenantInfo = this.tenantService.getTenantInfo(); // TM-1000001963
        this.tenantName = tenantInfo?.tenant; // TM-1000001963

        // Default to logoColorDark (colored logo on light/default background)
        this.tenantLogo = tenantInfo?.logoColorDark || tenantInfo?.logo; // TM-1000001963

        // TM-1000001963: precompute the background style once so the template binding does
        // not change after change detection has run (avoids NG0100 on the topbar background).
        // No detectChanges() here - the initial CD pass picks up the value naturally.
        this.computeTopbarBackground(); // TM-1000001963

        this.indicatorSubscription = this.topbarService.coreIndicatorButtonSubscription.subscribe((buttons) => {
            this.buttons = buttons;
        });

        this.navigationService.navigationObjectOverlay.subscribe(navItem => {
            this.refreshOverlayObject(navItem);
        });

        this.userService.getPictureBinary().subscribe(res => {
            UserProfileHelper.getImageSrcFromBlob(res).then(imageSrc => {
                this.profilePicture = imageSrc;
            });
        });

        this.profileSubscription = this.userService.profileSubscription.subscribe(res => {
            this.profilePicture = res;
        });

        this.getTopbarTheme();

    }

    ngAfterViewInit() {
        this.handleTopbarTheme()
    }

    getTopbarTheme() {
        const userSettings = localStorage.getItem('ui.userSettings');

        if (userSettings) {
            this.uiUserSettings = JSON.parse(userSettings);
            return;
        }

        const meUser: string ='${E:ME_USERNAME}';

        const filterCriteria = new FilterCriteria();
        filterCriteria.addFilterCriteriaToOr(FilterCriteria.create('user', FilterCriteria.cOperatorEqual, meUser));
        filterCriteria.addFilterCriteriaToOr(FilterCriteria.create('user', FilterCriteria.cOperatorEqual, ''));


        const objectRequest = new ObjectRequestList(
            false,
            [filterCriteria],
            []
        );
        this.uiSettingUserService.list(objectRequest).subscribe(res => {
            if (!res.entries || !res.entries.length) {
                return;
            }
            let preferredSettings= null;
            const mySettings = res.entries.find(item => item.user != '');
            const defaultSettings = res.entries.find(item => item.user == '');

            if (mySettings) {
                preferredSettings = mySettings;
            } else if (defaultSettings) {
                preferredSettings = defaultSettings;
            }

            if (preferredSettings) {
                this.uiUserSettings = preferredSettings;
                this.handleTopbarTheme();
            }


        }, error => {
        })
    }

    handleTopbarTheme() {
        if (!this.uiUserSettings) {
            return;
        }
        this.userSettings = JSON.parse(this.uiUserSettings.layoutJson);
        localStorage.setItem('ui.userSettings', JSON.stringify(this.uiUserSettings));
        const theme = this.userSettings.topbarTheme;
        this.applyTopbarTheme(theme);

    }

    applyTopbarTheme(theme: UiThemeInterface) {
        if(typeof theme === "string") {
            this.app.topbarTheme = theme;
        } else {
            this.app.topbarTheme = theme.name;
        }

        const appIcons: NodeListOf<HTMLElement> = document.querySelectorAll('.dark-topbar-icon');
        const tenantInfo = this.tenantService.getTenantInfo(); // TM-1000001963
        const isLight = this.userSettings.topbarLogo === 'light';
        const iconColor = isLight ? 'var(--surface-0)' : 'var(--surface-500)';

        // TM-1000001963: guard tenantInfo access; keep previous logo if tenant not yet loaded.
        if (tenantInfo) {
            if (isLight) {
                this.tenantLogo = tenantInfo.logoColorBright || tenantInfo.logoBright || tenantInfo.logo; // TM-1000001963
            } else {
                this.tenantLogo = tenantInfo.logoColorDark || tenantInfo.logoDark || tenantInfo.logo; // TM-1000001963
            }
        }

        appIcons.forEach(icon => {
            icon.style.setProperty('color', iconColor, 'important');
        });

        // TM-1000001963: theme changed (runs from ngAfterViewInit / async subscriptions, i.e.
        // after the view was checked) -> recompute the background binding and flush change
        // detection in the same pass so the [style.background] expression stays stable (NG0100).
        this.computeTopbarBackground(); // TM-1000001963
        this.cdr.detectChanges(); // TM-1000001963
    }

    /**
     * TM-1000001963: Computes the topbar background from the current theme. Called from
     * ngOnInit and whenever the theme is (re)applied, so the bound value never mutates
     * mid change-detection cycle (prevents NG0100).
     */
    private computeTopbarBackground(): void { // TM-1000001963
        const theme = this.app?.topbarTheme;
        this.topbarBackground = theme && theme.startsWith('#') ? theme : null; // TM-1000001963
    }

    refreshOverlayObject(navItem: MvsObjectNavigationEntry[]) {
        if (this.currentOverlay.length == navItem.length) {
            return;
        }
        if (!navItem || !navItem.length) {
            this.objectLabel = null;
            this.currentOverlay = [];
        } else {
            this.objectLabel = this.navigationService.objectLabel;
            this.currentOverlay = navItem;
            this.handleDisplayStack();
            this.activeOverlay = this.navigationService.getActiveOverlay();
            this.activeOverlayIndex = this.navigationService.activeOverlayIndex;
            this.getLabels();
        }
    }

    handleDisplayStack() {
        for (let item of this.currentOverlay) {
            const exists = this.checkInDisplayStack(item.objectIdentifier);
            if (!exists) {
                this.displayStack.push(item);
            }
        }
    }

    checkInDisplayStack(objectIdentifier: ObjectIdentifier) {
        for (let item of this.displayStack) {
            const isSame = ObjectIdentifier.compare(item.objectIdentifier, objectIdentifier);
            if (isSame) {
                return true;
            }
        }
        return false;
    }

    getLabels() {
        for (let item of this.currentOverlay) {

            if (item['label']) {
                return;
            }

            const crudService = this.coreService.getCrudService(item.objectIdentifier.objectType);
            const objectLabels: string[] = crudService.getObjectLabels();
            crudService.get(item.objectIdentifier.objectId).subscribe(res => {

                for (let label of objectLabels) {
                    if (res[label]) {
                        item['label'] = res[label];
                        return;
                    }
                }
            });

        }
    }

    toggleOverlay(index: number): void {
        this.navigationService.setActiveOverlay(index);
        this.activeOverlay = this.navigationService.getActiveOverlay();
        this.activeOverlayIndex = this.navigationService.activeOverlayIndex;
    }

    ngOnDestroy() {
        this.indicatorSubscription.unsubscribe();

        if (this.profileSubscription) {
            this.profileSubscription.unsubscribe();
        }
    }

    onSearchAnimationEnd(event: AnimationEvent) {
        switch(event.toState) {
            case 'visible':
                this.searchInputViewChild.nativeElement.focus();
                break;
        }
    }

    handleHomePageNavigation() {
        this.navigationService.navigateToHomePage();
    }

    onNavigateToMainPage() {
        this.displayStack = [];
        this.navigationService.clearOverlay();
    }

    handleRemoveItem(index: number) {
        this.displayStack.splice(index,1);
        this.navigationService.removeOverlay(index);
    }

    handleNavigationToProfile() {
        const url = '/user/profile';
        this.navigationService.handlePageNavigation(url);
    }

    create(objectType: string) {
            const object = MvsObjectNavigationEntry.createNavigationEntry(objectType, null,null, null, null, null, MvsObjectNavigationActionEnum.any, 'side');
            this.navigationService.navigateTo(object, 'right');
    }

    handleLogoutUser(): void {
        this.tenantService.removeLocalStorageToken();
        this.oAuthService.logOut();
    }

}
